import {  Component, HostListener, OnInit } from '@angular/core';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { Subscription } from 'rxjs';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-square-payments',
  templateUrl: './square-payments.component.html',
  styleUrls: ['./square-payments.component.scss']
})
export class SquarePaymentsComponent implements OnInit {
  
  readonly PAYMENT_ENDPOINT = "https://payments.avantoeats.com/reginos/checkout/square/";

  //In order to test with test credentials, uncomment this:
  // readonly PAYMENT_ENDPOINT = "http://localhost/reginos/checkout/square/test";
  //Also, make sure to change loadSessionInformation.php, index.php and processPayment.php on the payment php project



  //Longest time the loading overlay waits for the payment page, in case its load event never arrives
  readonly PAGE_LOAD_FALLBACK_MS = 15000;

  //This will determine if we show the loading overlay on top of the screen or not
  isLoading:boolean;
  isPaymentPageLoaded:boolean = false;
  pageLoadFallbackTimer:any;
  //We use these so initial loading methods wont be called twice
  isContactlessDelivery:boolean;
  iframeEndpointReady:boolean;
  cartIsEmpty:boolean;
  
  //Other variables
  paymentEndpoint:SafeResourceUrl;
  sessionSubscription: Subscription = new Subscription();

  constructor(private avantoRoute: AvantoRoutingService, private avantoSession:AvantoSessionService, private route: ActivatedRoute) { }

  //Observes for messages coming from the IFRAME
  @HostListener("window:message", ["$event"])
    reciveDataFromIframe(event: MessageEvent) {
    //"Back to checkout" button clicked. We go back to the checkout page.
    if(event.data.backToCheckout != null && event.data.backToCheckout){
      this.goToCheckoutPage();
    }else if(event.data.showLoadingOverlay != null){
      this.isLoading = event.data.showLoadingOverlay;
    }else if(event.data.orderComplete != null && event.data.orderComplete){
      this.completePayment();
    }
  }


  ngOnInit() {
    this.isContactlessDelivery = false;
    if(this.route.snapshot.params['params'] == "contactless"){
      this.isContactlessDelivery = true;
    }

    this.isLoading    = true;
    this.cartIsEmpty = false;
    this.iframeEndpointReady = false;

      this.sessionSubscription = this.avantoSession.sessionSubject.subscribe((session) => {
        if(session.cart.cartItems.size == 0 || session.cart.total<=0){
          this.cartIsEmpty = true;
          this.isLoading   = false;
        } else if(!this.iframeEndpointReady){
          this.paymentEndpoint = this.PAYMENT_ENDPOINT+"?sessId="+session.sessionId+"&isContactless="+this.isContactlessDelivery;
          this.iframeEndpointReady = true;
          this.pageLoadFallbackTimer = setTimeout(() => {
            if(!this.isPaymentPageLoaded){
              this.isLoading = false;
            }
          }, this.PAGE_LOAD_FALLBACK_MS);
        }
    });
  }

  /** The iframe loads an empty page (about:blank) before the payment page. The overlay stays up until the payment page itself has loaded. */
  iframeLoaded(frame:HTMLIFrameElement){
    if(this.isBlankPage(frame)){
      return;
    }
    this.isPaymentPageLoaded = true;
    this.isLoading = false;
  }

  /** The payment page is on another domain, so reading its address throws. Only the empty page can be read. */
  private isBlankPage(frame:HTMLIFrameElement):boolean{
    try{
      return frame.contentWindow != null && frame.contentWindow.location.href == "about:blank";
    }catch(ex){
      return false;
    }
  }

  completePayment(){
    this.avantoSession.clearSession()
      .catch(() => {
        this.avantoSession.removeSessionFromCookie();
      })
      .finally(() => {
        this.avantoRoute.goToOrderCompletePage()
      })
  }


  goToCheckoutPage(){
    this.avantoRoute.goToCheckoutPage();
  }

  
  ngOnDestroy(){
    clearTimeout(this.pageLoadFallbackTimer);
    this.sessionSubscription.unsubscribe();
  }

}
